import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconClienteConjuge,
    SvgIconFamiliares,
    SvgIconEnderecos,
    SvgIconObjetivos,
    SvgIconRiscos,
} from '../../../business-components/SvgIcon/SvgIconCadastro/SvgIconCadastro'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import formList from '../../../business-rules/List/formList'

import FormFormPerguntas from '../form-form/FormFormPerguntas'

import CadastroFormClienteConjuge from './CadastroFormClienteConjuge'

import CadastroFormFamiliares from './CadastroFormFamiliares'

import CadastroFormEndereco from './CadastroFormEndereco'

import CadastroFormObjetivos from './CadastroFormObjetivos'

import RiscosForm from '../riscos-form/RiscosForm'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

const CadastroForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars, arquivoList, obterArquivoList }) => {

    const linhaFormList = pesquisaList(formList, values.idFormList)

    

    let stepsSvgIcon = []

    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosPerguntas) {

        stepsSvgIcon.push(
            SvgIconObjetivos,
        )
    }

    stepsSvgIcon.push(
        SvgIconClienteConjuge,
        SvgIconFamiliares,
        SvgIconEnderecos,
    )
 
    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosObjetivos) {

        stepsSvgIcon.push(
            SvgIconObjetivos,
        )
    }

    stepsSvgIcon.push(
        SvgIconRiscos,
    )



    let steps = []

    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosPerguntas) {

        steps.push(
            LABEL.perguntas,
        )
    }

    steps.push(
        values.possuiConjuge ? tituloCliente(values) + "/" + tituloConjuge(values) : tituloCliente(values),
        LABEL.familiares,
        LABEL.enderecos,
    )
 
    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosObjetivos) {

        steps.push(
            LABEL.objetivos,
        )
    }

    steps.push(
        LABEL.riscos,
    )



    let stepsContent = []

    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosPerguntas) {

        stepsContent.push(
            <FormFormPerguntas
                variaveisGlobais={variaveisGlobais}
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                handleSubmitAutomatico={handleSubmitAutomatico}
                vars={vars}
                //linhaTipoLicenca={vars.linhaTipoLicenca}
                //idConfiguracao={vars.idConfiguracao}
                //jsonConfiguracao={vars.jsonConfiguracao}
                //jsonUsuario={vars.jsonUsuario}
                //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                linhaFormList={linhaFormList}
                completo={true}
                arquivoList={arquivoList}
                obterArquivoList={obterArquivoList}
            />,
        )
    }

    stepsContent.push(
        <CadastroFormClienteConjuge
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            vars={vars}
            linhaFormList={linhaFormList}
        />,
        <CadastroFormFamiliares
            values={values} 
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
        />,
        <CadastroFormEndereco
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
        />,
    )
 
    if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosObjetivos) {

        stepsContent.push(
            <CadastroFormObjetivos
                variaveisGlobais={variaveisGlobais}
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                vars={vars}
            />,
        )
    }

    stepsContent.push(
        <RiscosForm
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleSubmitAutomatico={handleSubmitAutomatico}
        />,
    )


    
    return (
        <StepperPadrao
            stepsType={"padrao"}
            stepsSvgIcon={stepsSvgIcon}
            steps={steps}
            stepsContent={stepsContent}
            valuesStep={values.stepCadastro}
            naoPermiteConcluir={true}
        />
    )
}

export default CadastroForm